import React, { useEffect, useRef, useState } from "react";
import { useThemeContext } from "../../../Context/ThemeContext";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  MenuItem,
  Select,
  TablePagination,
  Tooltip,
  Typography,
} from "@mui/material";
import "./Transcations.css";
import {
  getTransactionsData,
  getReturnTransactionsData,
  getFranchiseMachineType,
  getMachineLocations, // TODO: rename to the function Sidebar.js uses
} from "../../../Services/authService";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import * as XLSX from "xlsx";
import { DropDownIcon } from "../../../Components/Layouts/CustomIcons";
import CardGroup from "../../../Components/Common/CardGroup";
import Card1 from "../../../assets/Cards/Card1.webp";
import Card2 from "../../../assets/Cards/Card2.webp";
import Card3 from "../../../assets/Cards/Card3.webp";
import Card4 from "../../../assets/Cards/Card4.webp";
import TransactionsTable from "./TransactionsTable";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import LocationPopup from "../LocationPopup";
import dayjs from "dayjs";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "../../../Styles/daterange-responsive.css";
import { DateRange } from "react-date-range";
import { useLocation } from "react-router-dom";
import SectionLoader from "../../../Components/Common/SectionLoader";
import SuccessNotification from "../../../Components/Common/SuccessNotification";
import {
  formatDate,
  formatDateTime,
  formatTime,
} from "../../../Components/Common/dateFormat";

// ---------- module-level constants / helpers ----------
const EMPTY_RANGE = [{ key: "selection" }];
const ellipsis = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "inline-block",
  maxWidth: "100%",
};
const tooltipStyle = {
  tooltip: {
    sx: { fontSize: "13px", letterSpacing: "0.8px", lineHeight: "1.4" },
  },
};
const getBackendStatus = (status) =>
  status === "partial_failure" ? "Partial Failure" : status;

const isPartialFailure = (status) => {
  const normalized = String(status ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  return normalized === "partial_failure" || normalized === "partial_failed";
};

const scrollbarSx = (track, thumb, w = "10px", h = "10px") => ({
  "&::-webkit-scrollbar": { width: w, height: h },
  "&::-webkit-scrollbar-track": {
    backgroundColor: track,
    border: `1px solid ${thumb}`,
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: thumb,
    borderRadius: "10px",
    border: "3px solid transparent",
    backgroundClip: "padding-box",
  },
});

const EllipsisCell = (text, title = text) => (
  <Tooltip title={title || ""} arrow componentsProps={tooltipStyle}>
    <span style={ellipsis}>{text}</span>
  </Tooltip>
);

const DateCell = (row) => (
  <Tooltip
    title={formatDateTime(row.transactionDate)}
    arrow
    componentsProps={tooltipStyle}
  >
    <span style={{ display: "inline-block", maxWidth: "100%" }}>
      <span style={{ whiteSpace: "nowrap", display: "block" }}>
        {formatDate(row.transactionDate)}
      </span>
      {formatTime(row.transactionDate) !== "-" && (
        <span style={{ whiteSpace: "nowrap", display: "block" }}>
          {formatTime(row.transactionDate)}
        </span>
      )}
    </span>
  </Tooltip>
);

const saveXlsx = (data, sheetName, filePrefix) => {
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.json_to_sheet(data),
    sheetName,
  );
  const timestamp = new Date().toISOString().replace(/[-:T]/g, "").slice(0, 14);
  XLSX.writeFile(workbook, `${filePrefix}_${timestamp}.xlsx`);
};

function Transcations() {
  const { mode } = useThemeContext();
  const location = useLocation();
  const { t } = useTranslation();

  const getTranslatedMachineType = (machineType) =>
    machineType
      ? t(`vendingMachines.${machineType.split(" ")[0]}`, {
          defaultValue: machineType,
        })
      : "N/A";

  // ---------- refs ----------
  const calendarRef = useRef(null);
  const calendarButtonRef = useRef(null);

  // ---------- colors ----------
  const C = mode === "dark" ? DARKCOLORS : LIGHTCOLORS;
  const containerBackground = C.BackgroundCard;
  const btnColor = C.GreyScale10;
  const dropCircle = C.GreyScale50;
  const dropIcon = C.GreyScale80;
  const settingIconColor = C.HeadingLightBackground;
  const borderColor1 = C.GreyScale40;
  const btnColor1 = C.Primary500;
  const textColor = C.BodyLightBackground;
  const scroll1 =
    mode === "light"
      ? LIGHTCOLORS.BodyDarkBackground
      : DARKCOLORS.BodyLightBackground;
  const scroll = C.GreyScale40;

  // ---------- state ----------
  // const [franchiseType, setFranchiseType] = useState(null); // BOTH | VENDING_ONLY | RETURN_ONLY | NONE
  // const [transactionTab, setTransactionTab] = useState("sales");
  // const showSales =
  //   franchiseType === "BOTH" || franchiseType === "VENDING_ONLY";

  // const showReturns =
  //   franchiseType === "BOTH" || franchiseType === "RETURN_ONLY";

  const [franchiseType, setFranchiseType] = useState(null); // BOTH | VENDING_ONLY | RETURN_ONLY | RETURN_FOOD_VENDING | NONE
const [transactionTab, setTransactionTab] = useState("sales");

const isReturnFoodVending = franchiseType === "RETURN_AND_FOOD_VENDING";

const showSales =
  franchiseType === "BOTH" ||
  franchiseType === "VENDING_ONLY" ||
  isReturnFoodVending;

const showReturns =
  franchiseType === "BOTH" ||
  franchiseType === "RETURN_ONLY" ||
  isReturnFoodVending;

  
  const [cardData, setCardData] = useState([
    {
      value: "0",
      label: t("transactions.totalTransactions"),
      background: Card1,
    },
    { value: "0", label: t("transactions.successful"), background: Card2 },
    { value: "0", label: t("transactions.unsuccessful"), background: Card3 },
    {
      value: "0",
      label: t("transactions.remainingTransactions"),
      background: Card4,
    },
  ]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [statusFilter, setStatusFilter] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedALLLocations, setSelectedAllLocations] = useState(false);
  const [machineNumbers, setMachineNumbers] = useState([]);
  const [machineLocations, setMachineLocations] = useState([]);
  const [dateRange, setDateRange] = useState(EMPTY_RANGE);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [showNoDataNotification, setShowNoDataNotification] = useState(false);
  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });

  const [selectedLocation, setSelectedLocation] = useState("");

  // ---------- columns ----------
  const salesColumns = [
    {
      field: "transactionDate",
      label: t("transactions.transactionDate"),
      renderCell: DateCell,
    },
    {
      field: "transactionId",
      label: t("transactions.transactionId"),
      renderCell: (row) => EllipsisCell(row.transactionId),
    },
    { field: "location", label: t("transactions.location") },
    {
      field: "machine",
      label: t("transactions.machine"),
      renderCell: (row) => EllipsisCell(getTranslatedMachineType(row.machine)),
    },
    { field: "aisle", label: t("transactions.aisle"), align: "center" },
    {
      field: "productsCount",
      label: t("transactions.productsCount"),
    },
    {
      field: "offer",
      label: t("transactions.offer"),
      renderCell: (row) => {
        const offer = String(row.offer ?? "").trim();
        if (!offer || offer.toLowerCase() === "none") return "-";
        return offer
          .split(",")
          .map((part, i) => <div key={i}>{part.trim()}</div>);
      },
    },
    { field: "finalPrice", label: t("transactions.total") },
    { field: "paymentType", label: t("transactions.paymentType") },
    { field: "status", label: t("transactions.status") },
  ];

  const returnColumns = [
    {
      field: "transactionDate",
      label: t("transactions.transactionDate", "Transaction Date"),
      renderCell: DateCell,
    },
    {
      field: "transactionId",
      label: t("transactions.transactionId", "Transaction ID"),
      renderCell: (row) =>
        EllipsisCell(row.transactionId || "-", row.transactionId),
    },
    { field: "location", label: t("transactions.location", "Location") },
    {
      field: "machineNumber",
      label: t("transactions.machine", "Machine"),
      renderCell: (row) =>
        EllipsisCell(row.machineNumber || "-", row.machineNumber),
    },
    { field: "returnItem", label: t("transactions.returnItem", "Return Item") },
    {
      field: "quantity",
      label: t("transactions.quantity", "Quantity"),
      // align: "center",
    },
    {
      field: "amount",
      label: t("transactions.total", "Amount"),
      renderCell: (row) =>
        Number.isNaN(Number(row.amount)) ? (
          "-"
        ) : (
          <Typography sx={{ color: "#FF4141", fontsize: "13px" }}>
            € {Number(row.amount).toFixed(2)}
          </Typography>
        ),
    },
    {
      field: "customerType",
      label: t("transactions.customerType", "Customer Type"),
    },
    {
      field: "paymentType",
      label: t("transactions.paymentType", "Payment Type"),
    },
    { field: "status", label: t("transactions.status", "Status") },
  ];

  const columns = transactionTab === "returns" ? returnColumns : salesColumns;
  const isReturns = transactionTab === "returns";

  // ---------- calendar ----------
  const handleCalendarToggle = () => {
    if (calendarButtonRef.current) {
      const rect = calendarButtonRef.current.getBoundingClientRect();
      setCalendarPosition({
        top: rect.bottom + window.scrollY + 10,
        left: rect.left + window.scrollX,
      });
    }
    setIsCalendarOpen((prev) => !prev);
  };

  // ---------- date params (returns and sales use different keys) ----------
  const buildDateParams = (range) => {
    const p = {};
    if (range?.[0]?.startDate && range[0]?.endDate) {
      const { startDate, endDate } = range[0];
      if (transactionTab === "returns") {
        p.fromDate = dayjs(startDate).format("YYYY-MM-DD");
        p.toDate = dayjs(endDate).format("YYYY-MM-DD");
      } else {
        p.from = dayjs(startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
        p.to = dayjs(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
      }
    }
    return p;
  };

  const fetchReturns = (params) =>
    getReturnTransactionsData({
      ...params,
      sortBy: "transactionDate",
      direction: "DESC",
    });

  // ---------- fetch ----------
  const fetchTransactions = async (rangeOverride) => {
    try {
      setLoading(true);

      const params = {
        page,
        size: rowsPerPage,
        machineIds: machineLocations || [],
        status: statusFilter
          ? getBackendStatus(statusFilter)
          : location?.state?.referenceId
            ? "Failed"
            : statusFilter,
        ...buildDateParams(
          rangeOverride !== undefined ? rangeOverride : dateRange,
        ),
      };

      // ----- returns -----

      if (transactionTab === "returns") {
        const data = await fetchReturns(params);

        setCardData([
          {
            value: data?.totalTransactions ?? 0,
            label: t("transactions.totalTransactions", "Total Transactions"),
            background: Card1,
          },
          {
            value: data?.totalCompleted ?? 0,
            label: t("transactions.successful", "Successful"),
            background: Card2,
          },
          {
            value: data?.totalFailed ?? 0,
            label: t("transactions.unsuccessful", "Unsuccessful"),
            background: Card3,
          },
        ]);

        setRows(Array.isArray(data?.items) ? data.items : []);
        setTotalRows(data?.totalTransactions ?? 0);

        return;
      }

      // ----- sales -----
      const data = await getTransactionsData(params);

      setCardData([
        {
          value: data?.summary?.totalTransactions ?? 0,
          label: t("transactions.totalTransactions"),
          background: Card1,
        },
        {
          value: data?.summary?.successfulTransactions ?? 0,
          label: t("transactions.successful"),
          background: Card2,
        },
        {
          value: data?.summary?.failedTransactions ?? 0,
          label: t("transactions.unsuccessful"),
          background: Card3,
        },
        {
          value: data?.summary?.remainingTransactions ?? 0,
          label: t(
            "transactions.remainingTransactions",
            "Remaining Transactions",
          ),
          background: Card4,
        },
      ]);

      let transactions = data?.transactions?.content || [];
      const totalElements = data?.transactions?.totalElements || 0;

      // highlight transaction coming from navigation state
      const refId = location?.state?.referenceId;
      if (refId) {
        const highlighted = transactions.find((tx) => tx.id === refId);
        if (highlighted) {
          transactions = [
            { ...highlighted, isHighlighted: true },
            ...transactions.filter((tx) => tx.id !== refId),
          ];
        }
      }

      setRows(transactions);
      setTotalRows(totalElements);
    } catch (error) {
      console.error(t("transactions.errorFetchingTransactionsData"), error);
      setRows([]);
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };

  // ---------- handlers ----------
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
    setPage(0);
  };

  const handleLocationClick = () => {
    setIsPopupOpen(true);
  };

  const handleLocationPopupClose = () => {
    setIsPopupOpen(false);
  };

  const handleDateChange = (item) => setDateRange([item.selection]);

  // ---------- effects ----------

  // 1) load franchise machine type once, pick the starting tab
 useEffect(() => {
  const loadFranchiseType = async () => {
    try {
      const res = await getFranchiseMachineType();
      const raw = res?.data?.machineType || "NONE";
      // console.log("TRANSACTIONS machineType:", JSON.stringify(raw)); // DEBUG

      // trim, uppercase, spaces/hyphens -> underscore
      const type = String(raw).trim().toUpperCase().replace(/[\s-]+/g, "_");

      setFranchiseType(type);
      setTransactionTab(type === "RETURN_ONLY" ? "returns" : "sales");
      if (type === "NONE") setLoading(false);
    } catch (error) {
        console.error("Error loading franchise machine type:", error);
        setFranchiseType("BOTH"); // fallback so the page still works
      }
    };
    loadFranchiseType();
  }, []);

  // 2) fetch data (wait until franchise type is known)

  useEffect(() => {
    if (!franchiseType || franchiseType === "NONE") return;
    fetchTransactions();
  }, [
    page,
    rowsPerPage,
    statusFilter,
    machineLocations,
    transactionTab,
    franchiseType,
  ]);

  // 3) card labels on language / tab change
useEffect(() => {
  const labels =
    transactionTab === "sales"
      ? [
          t("transactions.totalTransactions"),
          t("transactions.successful"),
          t("transactions.unsuccessful"),
          t("transactions.remainingTransactions"),
        ]
      : [
          t("transactions.totalTransactions"),
          t("transactions.successful"),
          t("transactions.unsuccessful"),
        ];

  setCardData((prev) =>
    labels.map((label, i) => ({
      ...prev[i],
      label,
    })),
  );
}, [t, transactionTab]);

  // 4) close calendar on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        calendarButtonRef.current &&
        !calendarButtonRef.current.contains(event.target)
      )
        setIsCalendarOpen(false);
    };
    if (isCalendarOpen)
      document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isCalendarOpen]);

  // ---------- row selection ----------
  const handleRowSelect = (row) =>
    setSelectedRows((prev) =>
      prev.some((r) => r.id === row.id)
        ? prev.filter((r) => r.id !== row.id)
        : [...prev, row],
    );

  const handleSelectAll = () => {
    setSelectedRows(selectAll ? [] : rows);
    setSelectAll(!selectAll);
  };

  // ---------- export ----------
  const fetchAllTransactionsForExport = async () => {
    const params = {
      page: 0,
      size: 100,
      status: statusFilter ? getBackendStatus(statusFilter) : undefined,
      machineIds: machineLocations || [],
      ...buildDateParams(dateRange),
    };

    // Returns
    if (transactionTab === "returns") {
      const data = await fetchReturns(params);

      return Array.isArray(data?.items) ? data.items : [];
    }

    // Sales
    const data = await getTransactionsData(params);

    return Array.isArray(data?.transactions?.content)
      ? data.transactions.content
      : [];
  };

  const salesHeaderOrder = [
    {
      key: "transactionDate",
      label: t("transactions.transactionDate", "Date"),
    },
    {
      key: "transactionId",
      label: t("transactions.transactionId", "Transaction ID"),
    },
    { key: "location", label: t("transactions.location", "Location") },
    { key: "machine", label: t("transactions.machine", "Machine") },
    { key: "aisle", label: t("transactions.aisle", "Aisle No.") },
    {
      key: "productsCount",
      label: t("transactions.productsCount", "Products Count"),
    },
    { key: "offer", label: t("transactions.offer", "Offer") },
    {
      key: "finalPrice",
      label: t("transactions.total", "Total(€) (Incl. 7% VAT)"),
    },
    {
      key: "paymentType",
      label: t("transactions.paymentType", "Payment Type"),
    },
    { key: "status", label: t("transactions.status", "Status") },
    { key: "reason", label: t("transactions.reason", "Reason") },
  ];

  const getExportPaymentType = (row) => {
    if (row.transactionType === "RETURN") return t("transactions.bowlReturn");
    if (row.paymentType === "Membership Card")
      return t("transactions.nafWallet");
    if (row.paymentType === "Credit/Debit Card")
      return t("membershipCards.cardType");
    if (row.paymentType === "Credit Card") return t("dashboard.creditCard");
    return row.paymentType ?? "";
  };

  const getExportStatus = (row) => {
    const statusKey =
      row.status?.toLowerCase().replace(/\s+/g, "_") === "partial_failure"
        ? "partialFailure"
        : row.status?.toLowerCase();
    return t(`transactions.${statusKey}`, { defaultValue: row.status });
  };

  const getExportPrice = (value) => {
    const [int, dec = ""] = String(parseFloat(value)).split(".");
    return `${int}.${(dec + "00").slice(0, 2)}`;
  };

  const transformSalesRow = (row) => {
    const newRow = {};
    salesHeaderOrder.forEach(({ key, label }) => {
      let value = row[key] ?? "";
      if (key === "transactionDate")
        value = formatDateTime(row.transactionDate);
      if (key === "finalPrice" && value !== "" && !isNaN(value))
        value = `€ ${getExportPrice(value)}`;

      if (
        key === "paymentType" &&
        (row.transactionType === "RETURN" ||
          ["Membership Card", "Credit/Debit Card", "Credit Card"].includes(
            row.paymentType,
          ))
      )
        value = getExportPaymentType(row);
      if (key === "machine") value = getTranslatedMachineType(row.machine);
      if (key === "status") value = getExportStatus(row);
      if (
        key === "offer" &&
        (!row.offer || String(row.offer).trim().toLowerCase() === "none")
      )
        value = "-";
      newRow[label] = value;
    });
    return newRow;
  };

  const transformReturnRow = (row) => ({
    [t("transactions.transactionDate", "Date")]: formatDateTime(
      row.transactionDate,
    ),
    [t("transactions.transactionId", "Transaction ID")]:
      row.transactionId ?? row.id ?? "",
    [t("transactions.location", "Location")]: row.location ?? "",
    [t("transactions.machine", "Machine")]: row.machineNumber ?? "",
    [t("transactions.returnItem", "Return Item")]: row.returnItem ?? "",
    [t("transactions.productsCount", "Quantity")]: row.quantity ?? "",
    [t("transactions.total", "Amount")]: row.amount ?? "",
    [t("transactions.customerType", "Customer Type")]: row.customerType ?? "",
    [t("transactions.paymentType", "Payment Type")]: row.paymentType ?? "",
    [t("transactions.status", "Status")]: row.status ?? "",
  });

  const handleExport = async () => {
    try {
      setLoading(true);

      let exportData = [];

      if (selectedRows.length > 0) {
        exportData = selectedRows;
      } else {
        exportData = await fetchAllTransactionsForExport();
      }

      if (!exportData || exportData.length === 0) {
        setShowNoDataNotification(true);
        return;
      }

      let transformedData = [];

      if (transactionTab === "sales") {
        transformedData = exportData.map(transformSalesRow);
      } else {
        transformedData = exportData.map(transformReturnRow);
      }

      const worksheet = XLSX.utils.json_to_sheet(transformedData);

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        transactionTab === "sales" ? "Transactions" : "Returns",
      );

      const timestamp = new Date()
        .toISOString()
        .replace(/[-:T]/g, "")
        .slice(0, 14);

    const fileName =
  transactionTab === "sales"
    ? t("transactions.sales_export_file_name", "Transactions")
    : t("transactions.returns_export_file_name", "Returns");

XLSX.writeFile(workbook, `${fileName}_${timestamp}.xlsx`);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // ---------- location / date apply & reset ----------
  const handleLocationSubmit = (locations, isAllSelected) => {
    setSelectedAllLocations(isAllSelected);
    const ids = [];
    const locs = [];
    locations.forEach((loc) =>
      loc.machines.forEach((machine) => {
        ids.push(machine.machineId);
        locs.push(machine.location);
      }),
    );
    setMachineNumbers(locs);
    setMachineLocations(ids);
    setPage(0);
  };

  const handleApply = () => {
    setPage(0);
    fetchTransactions();
    setIsCalendarOpen(false);
  };
  const handleReset = () => {
    setDateRange(EMPTY_RANGE);
    setIsCalendarOpen(false);
    setPage(0);
    fetchTransactions([]);
  };

  const handleTabChange = (tab) => {
    setTransactionTab(tab);
    setPage(0);
    setRows([]);
    setSelectedRows([]);
    setSelectAll(false);
    setStatusFilter("");
    setDateRange(EMPTY_RANGE);
    setMachineLocations([]);
    setMachineNumbers([]);
    setSelectedAllLocations(false);
  };

  // ---------- UI helpers ----------
  const statusLabels = {
    Completed: t("transactions.completed"),
    Failed: t("transactions.failed"),
    partial_failure: t("transactions.partialFailure"),
  };

  const tabs = [
    {
      id: "sales",
      key: "transactions.sales",
      fallback: t("sales_analytics.sales_tab"),
      visible: showSales,
    },
    {
      id: "returns",
      key: "transactions.returns",
      fallback: t("sales_analytics.returns_tab"),
      visible: showReturns,
    },
  ].filter((tab) => tab.visible);

  const dateLabel =
    dateRange[0]?.startDate && dateRange[0]?.endDate
      ? `${dayjs(dateRange[0].startDate).format("DD MMM YYYY")} - ${dayjs(dateRange[0].endDate).format("DD MMM YYYY")}`
      : t("sales_analytics.select_date_range");

  // ---------- render ----------
  return (
    <>
      <div
        className={`dashboard-container-overview ${mode === "dark" ? "dark-mode" : ""}`}
      >
        {/* SALES / RETURNS TABS (only when both are available) */}
        {tabs.length > 0 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "30px",
              marginBottom: "20px",
            }}
          >
            {tabs.map(({ id, key, fallback }) => {
              const active = transactionTab === id;
              return (
                <Typography
                  key={id}
                  onClick={() => handleTabChange(id)}
                  sx={{
                    cursor: "pointer",
                    color: active ? "#4C33DB" : "#BDBDBD",
                    fontSize: "25px",
                    fontWeight: active ? 500 : 400,
                    position: "relative",
                  }}
                >
                  {t(key, fallback)}
                  {active && (
                    <Box
                      sx={{
                        position: "absolute",
                        width: "4px",
                        height: "4px",
                        backgroundColor: "#4C33DB",
                        borderRadius: "50%",
                        bottom: "-8px",
                        left: "50%",
                        transform: "translateX(-50%)",
                      }}
                    />
                  )}
                </Typography>
              );
            })}
          </Box>
        )}

        {/* CARDS */}
        <div className="transactions-card-section">
          <CardGroup cardData={cardData} />
        </div>

        {/* MAIN TABLE CONTAINER */}
        <Box style={{ background: containerBackground, borderRadius: "12px" }}>
          {/* TABLE HEADER */}
          <Box
            className="view-table-header-sec"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
            }}
          >
            {/* LOCATION + DATE */}
            {/* LEFT SIDE - LOCATION + FILTER */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              {/* SELECT LOCATION */}
              <Button
                id="view-trans-select"
                className="add-machine"
                onClick={handleLocationClick}
                sx={{
                  borderRadius: "24px",
                  textAlign: "center",
                  padding: "9px 20px",
                  display: "flex",
                  alignItems: "center",
                  color: settingIconColor,
                  background: btnColor,
                  textTransform: "none",
                  justifyContent: "space-between",
                  gap: "8px",
                  minWidth: "160px",
                }}
                endIcon={<DropDownIcon color1={dropCircle} color2={dropIcon} />}
              >
                {t("transactions.selectLocation")}
              </Button>

              <LocationPopup
                open={isPopupOpen}
                onClose={handleLocationPopupClose}
                selectedMachineLocations={selectedLocation}
                onSubmit={handleLocationSubmit}
                machineType={isReturns ? "Return Vending Machine" : undefined}
                excludeMachineType={
                  isReturns ? undefined : "Return Vending Machine"
                }
              />

              {/* FILTER */}
              <Select
                className="view-sort"
                value={statusFilter}
                onChange={handleStatusFilterChange}
                displayEmpty
                size="small"
                IconComponent={(props) => (
                  <DropDownIcon
                    color1={dropCircle}
                    color2={dropIcon}
                    {...props}
                  />
                )}
                sx={{
                  borderRadius: "24px",
                  border: "0px solid transparent",
                  textAlign: "center",
                  paddingRight: "12px",

                  "& .MuiSelect-select": {
                    padding: "9px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },

                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: `0.5px solid ${borderColor1}`,
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      borderRadius: "16px",
                      border: `0px solid ${borderColor1}`,
                      boxShadow: "none",
                      backgroundColor: containerBackground,
                      padding: "10px",
                      marginTop: "10px",
                    },
                  },
                }}
                renderValue={(selected) =>
                  selected === "" ? (
                    <p className="sort-filter-text">
                      {t("membershipCards.filter")}
                    </p>
                  ) : (
                    statusLabels[selected] || selected
                  )
                }
              >
                <MenuItem className="menu-item-sec" value="">
                  {t("membershipCards.all")}
                </MenuItem>

                <MenuItem className="menu-item-sec" value="Completed">
                  {t("transactions.completed")}
                </MenuItem>

                <MenuItem className="menu-item-sec" value="Failed">
                  {t("transactions.failed")}
                </MenuItem>

                {!isReturns && (
                  <MenuItem className="menu-item-sec" value="partial_failure">
                    {t("transactions.partialFailure")}
                  </MenuItem>
                )}
              </Select>
            </Box>

            {/* RIGHT SIDE - DATE RANGE + EXPORT */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              {/* DATE RANGE */}
              <Button
                ref={calendarButtonRef}
                aria-label="select-date"
                onClick={handleCalendarToggle}
                sx={{
                  background: btnColor,
                  borderRadius: "50px",
                  padding: "8px 14px",
                  color: dropIcon,
                  textTransform: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Typography
                  id="date-range"
                  sx={{ fontSize: "13px", color: textColor, fontWeight: 500 }}
                >
                  {dateRange[0]?.startDate && dateRange[0]?.endDate
                    ? `${dayjs(dateRange[0].startDate).format("DD MMM YYYY")} - ${dayjs(dateRange[0].endDate).format("DD MMM YYYY")}`
                    : t(
                        "sales_analytics.select_date_range",
                        "Select Date Range",
                      )}
                </Typography>
                <CalendarTodayOutlinedIcon style={{ fontSize: "1rem" }} />
              </Button>
              {/* Date Range Picker */}
              {isCalendarOpen && (
                <div
                  id="calender-res"
                  ref={calendarRef}
                  style={{
                    background: containerBackground,
                    position: "absolute",
                    top: `${calendarPosition.top}px`,
                    left: `${calendarPosition.left}px`,
                    transform: "translateX(-60px)",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "12px",
                    "@media (max-width: 600px)": {
                      left: "-6px !important",
                    },
                  }}
                >
                  <DateRange
                    editableDateInputs={true}
                    onChange={handleDateChange}
                    moveRangeOnFirstSelection={false}
                    ranges={dateRange}
                    style={{
                      borderRadius: "12px",
                      padding: "8px",
                    }}
                  />
                  <div
                    style={{
                      textAlign: "right",
                      margin: "1rem 0.5rem",
                      display: "flex",
                      gap: "0.5rem",
                      justifyContent: "flex-end",
                    }}
                  >
                    <button
                      className="cancel-btn"
                      type="button"
                      style={{
                        color: btnColor1,
                        borderColor: btnColor1,
                        padding: "10px 15px",
                        fontSize: "15px",
                      }}
                      onClick={handleReset}
                    >
                      {t("sales_analytics.reset", "Reset")}
                    </button>
                    <button
                      type="button"
                      style={{
                        background: btnColor1,
                        padding: "10px 15px",
                        fontSize: "15px",
                      }}
                      className="save-btn"
                      onClick={handleApply}
                    >
                      {t("sales_analytics.apply")}
                    </button>
                  </div>
                </div>
              )}

              {/* EXPORT */}
              <Button
                className="export-btn"
                style={{
                  fontSize: "13px",
                  color: settingIconColor,
                  // background: "#78F080",
                  border: `0.5px solid ${borderColor1}`,
                  padding: "9.5px 26px",
                }}
                onClick={handleExport}
                endIcon={<FileUploadOutlinedIcon className="export-icon" />}
              >
                {t("membershipCards.export")}
              </Button>
            </Box>
          </Box>

          {/* LOADING / EMPTY / TABLE */}
          {loading ? (
            <Box
              sx={{
                height: "50vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <SectionLoader />
            </Box>
          ) : rows.length === 0 ? (
            <Box
              sx={{
                height: "300px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "18px",
                color: C.GreyScale40,
              }}
            >
              {t("transactions.noDataFound") ||
                "No transactions found for the selected filters."}
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  width: "100%",
                  overflowX: "auto",
                  overflowY: "auto",
                  ...scrollbarSx(
                    scroll1,
                    scroll,
                    "10px !important",
                    "8px !important",
                  ),
                }}
              >
                <TransactionsTable
                  rows={rows || []}
                  columns={columns || []}
                  onRowSelect={handleRowSelect}
                  onSelectAll={handleSelectAll}
                  selectedRows={selectedRows || []}
                  selectAll={selectAll}
                />
              </Box>

              <TablePagination
                component="div"
                count={totalRows}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={t(
                  "membershipCards.RowsPerPage",
                  "Rows Per Page",
                )}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  overflowX: "auto",
                  ...scrollbarSx(scroll1, scroll),
                }}
              />
            </>
          )}
        </Box>
      </div>

      {/* NO DATA NOTIFICATION */}
      <SuccessNotification
        open={showNoDataNotification}
        message={t("discounts.Nodataexport")}
        severity="warning"
        onClose={() => setShowNoDataNotification(false)}
      />
    </>
  );
}

export default Transcations;
